// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__l00Z0","user":"Banner_user__JC1ua","docs":"Banner_docs__nJmvH"};